export default "__VITE_ASSET__Dfpg6eMQ__";